import * as types from "./mutation-type";
import { getSkillsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getSkills({ commit }, variables = {}) {
    try {
      commit(types.GET_SKILLS_BEGIN);
      const {
        data: {
          data: {
            company: {
              skills
            }
          }
        }
      } = await gqlClient.query({
        query     : getSkillsQuery,
        variables : variables
      });
      commit(types.GET_SKILLS_SUCCESS, skills);
    } catch (e) {
      commit(types.GET_SKILLS_ERROR, e);
    }
  },
  async deleteSkill({ commit }, id) {
    try {
      commit(types.DELETE_SKILL_BEGIN);
      await api.skill.deleteSkill(id);

      commit(types.DELETE_SKILL_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_SKILL_ERROR, e);
    }
  },

  async createSkill({ commit }, variables ) { 
    try {
      commit(types.CREATE_SKILL_BEGIN)
      const { data } = await api.skill.addSkill(variables)
      commit(types.CREATE_SKILL_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_SKILL_ERROR, e)
    }
  },

  //update skill by its id
  async updateSkill({ commit }, { id, data }){
    commit(types.UPDATE_SKILL_BEGIN)
    try {
      const { data:updatedData } = await api.skill.update(id,data)
      commit(types.UPDATE_SKILL_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_SKILL_ERROR, error)
    }
  },

  //create skill in user_emp section
  async createUserSkill({ commit, rootState }, userData) {
    try {
      commit(types.ADD_USER_SKILL_BEGIN,userData.userId)
      const { data } = await api.userSkill.addUserSkill(userData)
      commit(types.ADD_USER_SKILL_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_USER_SKILL_ERROR, { err,userId : userData.userId })
    }
  },

  //delete skill in user_emp section
  async deleteUserSkill({ commit, rootState }, { id, userId }) {
    try {
      commit(types.DELETE_USER_SKILL_BEGIN, userId);
      await api.userSkill.delUserSkill(id);
      commit(types.DELETE_USER_SKILL_SUCCESS, { userId, rootState });
    } catch (err) {
      commit(types.DELETE_USER_SKILL_ERROR, { err, userId });
    }
  }
  
};

export default actions;
